import { GetCityIdWithSection } from "hooks/returnCityName"
import {
  UPDATE_SIGNATURE_EXECUTOR_SUCCESS,
  UPDATE_SIGNATURE_EXECUTOR_FAIL,
  RESET_EXECUTOR_FLAG,
  SEND_SMS_PAYMENT_SUCCESS,
  SEND_SMS_PAYMENT_FAIL,
  UPDATE_SIGNATURE_EXECUTOR,
  SEND_SMS_PAYMENT,
  GET_LIST_EXECUTOR,
  GET_LIST_EXECUTOR_SUCCESS,
  GET_LIST_EXECUTOR_FAIL,
  GET_LIST_EXECUTOR_FILTER,
  INACTIVE_EXECUTOR,
  INACTIVE_EXECUTOR_SUCCESS,
  INACTIVE_EXECUTOR_FAIL,
  UPSERT_EXECUTOR,
  UPSERT_EXECUTOR_FAIL,
  UPSERT_EXECUTOR_SUCCESS,
  FILTER_EXECUTOR,
  FILTER_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  signatureFileName: "",
  lstExecutor: [],
  lstExecutorDefault: [],
  error: null,
  success: null,
  loading: false,
  actionName: {},
}

const filterExecutor = (state, payload) => {
  if (state.lstExecutorDefault?.length > 0) {
    let lstEng = JSON.parse(JSON.stringify(state.lstExecutorDefault))
    if (payload.fullName.length > 0)
      lstEng = lstEng.filter(f => f.fullName.includes(payload.fullName))
    else if (payload.idSection !== 0) {
      if (payload.filterAddress === 1) {
        const idCity = GetCityIdWithSection(payload.idSection).Id

        lstEng = lstEng.filter(
          f => GetCityIdWithSection(+f.idSection).Id === idCity
        )
      }
      if (payload.filterAddress === 2) {
        lstEng = lstEng.filter(f => +f.idSection === +payload.idSection)
      }
    }

    return lstEng
  }
  return state.lstExecutor
}

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LIST_EXECUTOR_FILTER:
      return {
        ...state,
        lstExecutor: state.lstExecutor.filter(
          c => c.cellPhone === action.payload
        ),
      }
    //#region loading
    case UPDATE_SIGNATURE_EXECUTOR:
    case SEND_SMS_PAYMENT:
    case GET_LIST_EXECUTOR:
    case INACTIVE_EXECUTOR:
    case UPSERT_EXECUTOR:
      return {
        ...state,
        loading: true,
      }
    //#endregion

    //#region Success

    case UPSERT_EXECUTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      }

    case UPDATE_SIGNATURE_EXECUTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        signatureFileName: action.payload,
        success: "فایل با موفقیت ارسال شد",
        error: null,
      }
    case SEND_SMS_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "پیام برای مالک ارسال گردید",
        error: null,
      }
    case GET_LIST_EXECUTOR_SUCCESS:
      return {
        ...state,
        lstExecutor: action.payload,
        lstExecutorDefault: action.payload,
        loading: false,
        success: "لیست مجریان با موفقیت بارگذاری شد",
        error: null,
      }
    case INACTIVE_EXECUTOR_SUCCESS:
      return {
        ...state,
        lstExecutor: state.lstExecutor.map(x => {
          if (x.id === action.payload.id)
            return {
              ...x,
              inactive: action.payload.inactive,
              inactiveDes: action.payload.des,
            }
          return x
        }),
        loading: false,
        success: "عملیات انجام شد",
        error: null,
      }
    //#endregion

    case UPDATE_SIGNATURE_EXECUTOR_FAIL:
    case SEND_SMS_PAYMENT_FAIL:
    case GET_LIST_EXECUTOR_FAIL:
    case INACTIVE_EXECUTOR_FAIL:
    case UPSERT_EXECUTOR_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload : "خطای پیش بینی نشده",
        success: "",
      }

    case FILTER_EXECUTOR:
      return {
        ...state,
        lstExecutor: filterExecutor(state, action.payload),
        loading: false,
        error: null,
        success: null,
      }

    case FILTER_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    //#region Reset
    case RESET_EXECUTOR_FLAG:
      return {
        ...state,
        error: null,
        success: null,
      }
    //#endregion
    default:
      return state
  }
}

export default reducer
